export function EmptyState({ title, description, hint }) {
  return (
    <div className="card text-center py-10">
      <div className="text-lg font-semibold mb-1">{title}</div>
      <div className="subtle">{description}</div>
      {hint && <div className="text-xs subtle mt-3 max-w-md mx-auto">{hint}</div>}
    </div>
  );
}
